module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-07.4228f7d7.png";